export const updateCeoAccountStatus = (ceoAccountStatus) => {
    return {
        type: "UPDATECEOACCOUNT",
        payload: ceoAccountStatus,
    };
};